import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { get } from 'lodash';
import { IExistingSendRequest, IRequestsSendDetailEdit } from './_types';
import { getRequest } from '../_api';
import StudiesSendDetail from 'modules/Studies/StudiesSend/StudiesSendDetail';
import { IStudy } from 'modules/Studies/StudyDetail/_types';
import { useEntityInfo } from 'utils/hooks/useEntityInfo';
import { useAppGlobals } from 'utils/hooks/useAppGlobals';

const RequestsSendDetailEdit: React.FC<IRequestsSendDetailEdit> = () => {
  const { id } = useEntityInfo();
  const { toggleLoader } = useAppGlobals();
  const navigate = useNavigate();

  const [request, fetchRequest] = useState<IExistingSendRequest>();
  const [studies, fetchStudies] = useState<IStudy[]>();

  const loadEntity = async () => {
    if (id) {
      toggleLoader();
      const request = (await getRequest(parseInt(id.toString(), 10))) as
        | IExistingSendRequest
        | false;
      if (request) {
        fetchRequest(request);
        fetchStudies(get(request, 'data.studies'));
      } else {
        navigate('/requests/send');
      }
      toggleLoader(false);
    }
  };

  useEffect(() => {
    loadEntity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {request ? (
        <StudiesSendDetail
          isRequest={true}
          isRequestEdit={true}
          studiesFromRequest={studies}
          request={request}
        />
      ) : null}
    </>
  );
};

export default RequestsSendDetailEdit;
